export const viewData = [
  { value: 'shelf', label: 'shelf view' },
  { value: 'chart', label: 'chart view' },
  { value: 'table', label: 'table view' },
];
